/*
 * @Author: lyx
 * @Date: 2024-09-07 16:47:37
 * @LastEditors: lyx 
 * @LastEditTime: 2024-09-07 16:47:37
 * @FilePath: /dbrank_b/src/routes/visualChart/P33/index.js
 * @Description: p33
 */
import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./index.css";
import Stage from "../components/Stage";
import setChart from "./chart";
import Chart from "../components/Chart";
import { Title4 } from "../components/Titles";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./Form";
import FormChart from "./FormChart";
import DBTable from "../components/DBTable";
import { applyThousands } from "../utils";


class P33 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      brandArr: [],
      tableColumns: [],
      tableList: [],
      tableColorList: [],
    };
  }
  getMaxIndexForKey = (arr) => {
    if (arr) {
      let keys = new Set();
      arr.forEach((item) => {
        for (let key in item) {
          if (key !== "customKey") {
            keys.add(key);
          }
        }
      });
      let maxValues = {};
      Array.from(keys).map((item) => {
        maxValues[item] = -Infinity;
      });
      arr.forEach((item) => {
        for (let key in item) {
          if (key !== "customKey") {
            maxValues[key] = Math.max(maxValues[key], item[key]);
          }
        }
      });
      return maxValues;
    }
  };

  fillColor = (tableColumns, tableList) => {
    const border = "2px solid #000";
    const maxValues = this.getMaxIndexForKey(tableList);
    return tableColumns.map(({ children, ...item }) => {
      return {
        ...item,
        ...(Array.isArray(children) && { children: this.fillColor(children, tableList) }),
        style: {
          ...item.style,
          height: 20,
          fontSize: 14,
          fontWeight: 'bolder',
          textAlign: "center",
          background: "#fff",
          color: "#000",
          borderRight: border,
          borderBottom: border,
          whiteSpace: "nowrap",
        },
        colStyle: (_, ii, i) => {
          // console.log(ii, i);
          // console.log(tableList);

          return {
            height: 20,
            // fontSize: tableList[ii]['customKey'] === '安踏' ? 16 : 14,
            fontSize: 14,
            // fontWeight: 700,
            fontWeight: tableList[ii]['customKey'] === '安踏' ? 'bold' : 'normal',
            background: "#fff",
            textAlign: "center",
            borderRight: border,
            borderBottom: border,
            color:maxValues[_.dataIndex] == tableList[ii][_.dataIndex] ? "#f00" : "#000",
          };
        },
      };
    });
  };

  render() {
    const {
      chartTitle,
      chartList,
      tableColumns,
      tableList,
      chartColorList,
      brandArr,
    } = this.state;

    return (
      <Stage>
        <Title4 pageNumber="3.1">
          <span style={{ fontSize: "40px" }}>
            安踏VS竞品 | 全媒介渠道整体传播效果对比
          </span>
          <span style={{ fontSize: "20px" }}>（按媒体源）</span>
        </Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              均侧重在大众、行业自媒体传播。安踏在传统中央级媒体的发文量和数字品牌价值均最高
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: "100%", height: "100%" }}
                formContent={
                  <FormChart
                    onChange={(values) => this.setState({ ...values })}
                  />
                }
              >
                <Chart
                  options={setChart({
                    title: chartTitle,
                    list: chartList,
                    color: chartColorList,
                    brandArr: brandArr,
                  })}
                />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer
                formContent={
                  <Form onChange={(values) => this.setState({ ...values })} />
                }
              >
                <DBTable
                  columns={this.fillColor(tableColumns, tableList)}
                  data={applyThousands(tableList)}
                  style={{
                    borderTop: `2px solid #000`,
                    borderLeft: `2px solid #000`,
                  }}
                />
                {/* <DBTable columns={this.fillColor(tableColumns)} data={tableList} style={{ boxShadow: 'none' }} /> */}
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P33);


// WEBPACK FOOTER //
// src/routes/visualChart/P33/index.js